import SvgChevron from '@img/icons/chevron-right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Dropdown.styles';
const Dropdown = React.forwardRef(({ children, hasError = false, ...otherProps }, ref) => {
    const [open, setOpen] = React.useState(false);
    return (React.createElement(S.Container, { "data-open": open, "data-value": !!otherProps.value },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Select, { ref: ref, "data-error": hasError, onClick: () => setOpen(!open), onBlur: () => setOpen(false), onKeyDown: (event) => {
                    switch (event.key) {
                        case ' ':
                        case 'Enter':
                            setOpen(!open);
                            break;
                        default:
                            break;
                    }
                }, onChange: (event) => {
                    setOpen(false);
                    if (otherProps.onChange) {
                        otherProps.onChange(event);
                    }
                }, ...otherProps }, children)),
        React.createElement(SvgChevron, null)));
});
Dropdown.displayName = 'Dropdown';
export default Dropdown;
